import { GenericService } from 'services/genericService';
import { getResources } from 'utils/api/queries/omantelApi';
import { Observable } from 'rxjs';
import { Resources } from 'utils/api/models/resources/resources';
import { getTCFBB } from 'utils/api/queries/wcm';
import { getAvailableNumbers } from 'utils/api/queries/microApi';
import { AvailableNumbers } from 'utils/api/models/resources/availableNumbers';

export class ResourcesService extends GenericService {
	public static getResources(): Observable<Resources> {
		return getResources()
			.withErrorHandling()
			.call();
	}

	public static getTCFBB(): Observable<any> {
		return getTCFBB()
			.withErrorHandling()
			.call();
	}

	public static getAvailableNumbers(rowCount: string, numberSearch?: string): Observable<AvailableNumbers> {
		return getAvailableNumbers(rowCount, numberSearch)
			.withErrorHandling()
			.call();
	}
}
